import { render, staticRenderFns } from "./ViewReminder.vue?vue&type=template&id=57799eec&scoped=true&"
import script from "./ViewReminder.vue?vue&type=script&lang=js&"
export * from "./ViewReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57799eec",
  null
  
)

export default component.exports